module.exports = __webpack_public_path__ + "static/img/Bitmap1@2x.fcb85d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bitmap1@2x.png
// module id = 3oy/
// module chunks = 1